const BACK_END_URL = 'https://oregon-env-data-initiative.herokuapp.com'

export default BACK_END_URL;
